// extracted by mini-css-extract-plugin
module.exports = {"footerBar":"styles_footerBar__fIKP1","text":"styles_text__3ytlE","contactLinks":"styles_contactLinks__VVeyL","contact":"styles_contact__3LFi7"};